import clsx from 'clsx'
import React, { FC } from 'react'
import Switch from 'src/components/ui/Switch'

interface ILabeledSwitchProps {
  value?: boolean
  onChange?: (newValue: boolean) => void
  leftLabel?: string
  rightLabel?: string
  className?: string
  isGrayBackground?: boolean
  noPadding?: boolean
  onRightLabelClick?: () => void
}

const LabeledSwitch: FC<ILabeledSwitchProps> = ({
  leftLabel,
  rightLabel,
  onChange,
  value,
  className,
  isGrayBackground,
  noPadding,
  onRightLabelClick,
}) => (
  <>
    <div
      className={clsx(
        'flex items-center justify-start', 
        { 'py-2': !noPadding }, 
        className,
      )}
    >
      {leftLabel && 
        <p 
          className={clsx(
            'text-black-300 uppercase text-base font-bold leading-none', 
            value ? 'cursor-default' : 'cursor-pointer'
          )}
        >
          {leftLabel}
        </p>
      }
      <div className="leading-none">
        <Switch
          onChange={() => {
            onChange?.(!value)
          }}
          value={!!value}
          className="mx-4"
          isGrayBackground={isGrayBackground}
        />
      </div>
      {rightLabel && 
        <button
          type="button"
          onClick={() => {
            onRightLabelClick?.()
          }}
          className={clsx(
            'text-black-300 uppercase text-base font-bold leading-none', 
            onRightLabelClick ? 'cursor-ponter' : 'cursor-default',
          )}
        >
          {rightLabel}
        </button>
      }
    </div>
  </>
)

export default LabeledSwitch
